<div class="col-xl-9 col-lg-9 col-sm-9 mx-auto">
  <div class="app-content">
    <div>
      <div
      class="main-container"
      [ngClass]="{ 'container-fluid': mode == 'dark' }"
      id="custom-main-container"
      >
      <app-header-public></app-header-public>
        <router-outlet>
          <app-loader></app-loader>
        </router-outlet>
      </div>
    </div>
  </div>
</div>
<app-tab-to-top></app-tab-to-top>
